import config from './../config.json';
import http from './httpService';

export const getAllComments = (params, {cancelToken}) => {
    return http.get(config.api_comment, {params, cancelToken});
}

export const getItemComments = (params) => {
    return http.get(`${config.api_comment}/item-comments`, {params});
}

export const getUserComments = (params) => {
    return http.get(`${config.api_comment}/user-comments`, {params});
}

export const getProductComments = (params, {cancelToken}) => {
    return http.get(`${config.api_comment}/product-comments`, {params, cancelToken});
}

export const createComment = (comment) => {
	return http.post(`${config.api_comment}`, comment);
}

export const changeStatusCommentById = (_id) => {
	return http.get(`${config.api_comment}/${_id}`);
}

export const deleteCommentById = (_id) => {
	return http.delete(`${config.api_comment}/${_id}`);
}
